interface AnexoAgendamento {
  type?: string
  name?: string
}

export function analisarAnexosAgendamento(arquivos: readonly AnexoAgendamento[]) {
  const quantidadePdf = arquivos.filter((arquivo) => arquivo.type === 'application/pdf').length
  const quantidadeXml = arquivos.filter((arquivo) =>
    arquivo.type === 'application/xml' || arquivo.type === 'text/xml' || arquivo.name?.toLowerCase().endsWith('.xml'),
  ).length

  return { valido: quantidadePdf === 1 && quantidadeXml <= 1, temXml: quantidadeXml > 0 }
}
